export default __webpack_public_path__ + "static/media/FIAT.687f40a9.png";